const OCC_RANK = {
  d: 0,
  s: 1,
  t: 2,
  q: 3,
  p: 4,
  h: 5,
  hp: 6,
  o: 7,
  n: 8,
  de: 9,
  el: 10,
  tw: 11,
  th: 12,
  fo: 13,
};
const MEAL_RANK = { ep: 0, ro: 0, cp: 1, bb: 1, rwb: 1, map: 2, ap: 3 };
const CODE_MEAL = {
  ep: 'ep',
  ro: 'ep',
  cp: 'cp',
  bb: 'cp',
  rwb: 'cp',
  map: 'map',
  ap: 'ap',
};
const OCC_WORDS = [
  ['fourteen', 'fo'],
  ['thirteen', 'th'],
  ['twelve', 'tw'],
  ['eleven', 'el'],
  ['hept', 'hp'],
  ['hex', 'h'],
  ['oct', 'o'],
  ['pent', 'p'],
  ['quad', 'q'],
  ['triple', 't'],
  ['single', 's'],
  ['double', 'd'],
  ['non', 'n'],
  ['dec', 'de'],
];

export function ratePlanSortValue(plan) {
  const raw = plan?.sort_order ?? plan?.sortOrder ?? 0;
  const number = Number(raw);
  return Number.isFinite(number) ? number : 0;
}

function planId(plan) {
  const raw = plan?.id ?? plan?.rate_plan_id ?? plan?.ratePlanId ?? 0;
  const number = Number(raw);
  return Number.isFinite(number) ? number : 0;
}

function planName(plan) {
  return String(plan?.name || plan?.rate_plan_name || plan?.ratePlanName || '');
}

function planCode(plan) {
  return String(plan?.code || plan?.rate_plan_code || plan?.ratePlanCode || '').trim().toLowerCase();
}

function occupancyAndMeal(plan) {
  const parts = planCode(plan).split('-').filter(Boolean);
  if (parts.length >= 2 && Object.prototype.hasOwnProperty.call(OCC_RANK, parts[parts.length - 2])) {
    return [parts[parts.length - 2], parts[parts.length - 1]];
  }
  const name = planName(plan).toLowerCase();
  const occ = OCC_WORDS.find(([word]) => name.includes(word))?.[1] || '';
  const meal = String(plan?.meal_plan || plan?.mealPlan || '').trim().toLowerCase();
  return [occ, meal];
}

function mealToken(plan) {
  const [, parsedMeal] = occupancyAndMeal(plan);
  if (Object.prototype.hasOwnProperty.call(MEAL_RANK, parsedMeal)) return parsedMeal;
  const code = planCode(plan);
  if (CODE_MEAL[code]) return CODE_MEAL[code];
  const mealField = String(plan?.meal_plan || plan?.mealPlan || '').trim().toLowerCase();
  if (CODE_MEAL[mealField]) return CODE_MEAL[mealField];
  if (Object.prototype.hasOwnProperty.call(MEAL_RANK, mealField)) return mealField;
  const name = planName(plan).toLowerCase();
  if (name.includes('lunch') && name.includes('dinner')) {
    return name.includes(',') ? 'ap' : 'map';
  }
  if (name.includes('room only')) return 'ep';
  if (name.includes('breakfast')) return 'cp';
  return mealField;
}

function isOccupancyPlan(plan) {
  const [occ] = occupancyAndMeal(plan);
  return Object.prototype.hasOwnProperty.call(OCC_RANK, occ);
}

export function compareRatePlans(left, right) {
  const leftOccupancy = isOccupancyPlan(left);
  const rightOccupancy = isOccupancyPlan(right);
  const mealA = mealToken(left);
  const mealB = mealToken(right);
  const mealDiff = (MEAL_RANK[mealA] ?? 99) - (MEAL_RANK[mealB] ?? 99);

  // PMS meal plans: EP → CP → MAP → AP. Do not use leftover sort_order here.
  if (!leftOccupancy && !rightOccupancy) {
    if (mealDiff !== 0) return mealDiff;
    const order = ratePlanSortValue(left) - ratePlanSortValue(right);
    if (order !== 0) return order;
  } else {
    const order = ratePlanSortValue(left) - ratePlanSortValue(right);
    if (order !== 0) return order;
    if (mealDiff !== 0) return mealDiff;
    const [occA] = occupancyAndMeal(left);
    const [occB] = occupancyAndMeal(right);
    const occ = (OCC_RANK[occA] ?? 99) - (OCC_RANK[occB] ?? 99);
    if (occ !== 0) return occ;
  }

  const idDiff = planId(left) - planId(right);
  if (idDiff !== 0) return idDiff;
  return planName(left).localeCompare(planName(right));
}

export function sortRatePlans(plans) {
  return [...(plans || [])].sort(compareRatePlans);
}
